import { Component, OnInit } from '@angular/core';
import { BarcodeScanService } from './barcode-scan.service';
import { Barcode } from './barcode';
import { SelectableLab } from '../carrier/selectable-lab';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector: 'app-barcode-scan',
  templateUrl: './barcode-scan.component.html',
  styleUrls: ['./barcode-scan.component.css']
})
export class BarcodeScanComponent implements OnInit {

  latestBarcodes = new Array<Barcode>();
  userId: string = null;
  scannedBarcode: string;
  selectedLab:SelectableLab;

  constructor(private barcodeScanService: BarcodeScanService, private _messagesService: MessagesService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));  
  }

  ngOnInit() {
  }

  /**
   * This callback method will be called while scaning each barcode using handscanner.
   * It will be triggered on enter key press(Hand scanner configured with "Carrage return suffix")
   * On success - Adds the barcode to the list shown in UI
   * On error - Add the barcode to the list shown in UI with error flag set.
   * @method 
   * @param barcode 
   * @param userId 
  */
  saveBarcode(barcode: string, userId: string): any {

    if (barcode != undefined && barcode != null) {

      if( userId == undefined || userId == null || userId == "") {
        let message = { severity: 'error', summary: 'Please provide your 4 digit user id' };
        this._messagesService.addErrorMessage(message);
        return;
      }

      if (barcode == undefined || barcode == null || barcode == "") {
        return;
      }

      let newBarcode: Barcode = new Barcode(barcode.trim(), this.userId, this.selectedLab.lab);
      this.scannedBarcode = "";

      this.barcodeScanService.saveBarcode(newBarcode).subscribe(
        
        results => {
          console.log("newBarcode", results.data);
          this.updateLatestBarcodes(results.data);
        },
        error => {
          console.error("error in saving scanned barcode");
          newBarcode.error = true;
          this.updateLatestBarcodes(newBarcode);
        }
      );
    }

    this.scannedBarcode = "";
  }

  /**
   * Returns if there is a problem in saving a scanned barcode.
   * or there is a problem while sending message to GSB.
   * @param barcodeObj 
  */
  isError(barcodeObj: Barcode): boolean {
    return barcodeObj.error;
  }

  /**
   * Common utility to update latest barcodes shown in GUI,
   * Keep only last 5 scanned barcode. Discard older ones.
   * @param newBarcode 
   */
  updateLatestBarcodes(newBarcode: Barcode): any {

    this.latestBarcodes.unshift(newBarcode);

    if (this.latestBarcodes.length > 5) {
      this.latestBarcodes.pop();
    }
  }

  /**
   * On enter focus next input box(barcode)
   */
  focusBarcodeField(): any {
    document.getElementById("barcodeField").focus();
  }

  
  state(className: string, backendState: string): boolean {
    return className == backendState;
  }

}
